import TelehealthFile from "../Files/Telehealth Informed Consent (Zoom for Healthcare).pdf";
import BackgroundCheck from "../Files/Background Check Disclosure & Authorization.pdf";
import ClientParticipation from "../Files/Client Participation Agreement & Client Bill of Rights.pdf";
import PractitionerAgreement from "../Files/Nirva Practitioner Agreement (Independent Contractor) 2.pdf";
import ScopeOfPractice from "../Files/Nirva Practitioner Scope of Practice.pdf";

export const themeColors = [
  {
    id: 1,
    title: "Medium Neutral Gray",
    color: "#93938F",
    value: "neutralGray",
  },
  {
    id: 2,
    title: "Darker Muted Gray",
    color: "#576874",
    value: "mutedGray",
  },
  {
    id: 3,
    title: "Muted Green-Gray",
    color: "#4B5146",
    value: "greenGray",
  },
  {
    id: 4,
    title: "Lilac",
    color: "#E6E6FA",
    value: "lilac",
  },
  {
    id: 5,
    title: "Dusty Brown",
    color: "#AE8A71",
    value: "dustyBrown",
  },
  // {
  //   id: 6,
  //   title: "Brown-Yellowish Tan",
  //   color: "#c",
  //   value: "yellowishTan",
  // },
];

// Sidebar navigation tabs
// ---
// All tabs are visible to every user for a consistent experience across roles.
// Special flags:
//   `requiresIphc: true`  -> also requires an IphcPractitioner record (for active Nirva practitioners)
//   `section: "primary"`  -> shown in the top-level flat list
//   `section: "secondary"`-> shown under the collapsible "Learning & Resources" group

export const tabsData = [
  // ── Primary Navigation ──
  { name: "Home", id: "home", section: "primary" },
  // Hidden for Nirva practitioners (per client request — kept in code, just not shown to them).
  { name: "Messages", id: "messages", section: "primary", hideForIphc: true },
  { name: "Nirva Client Sessions", id: "patient", section: "primary", hideForIphc: true },
  { name: "Nirva Practitioner", id: "nirva", section: "primary" },
  { name: "IIH Training", id: "training", section: "primary" },
  { name: "IAIH Resources", id: "resources", section: "primary" },
  { name: "Blog", id: "blog", section: "primary" },
  { name: "Community Support Groups", id: "communitySupportGroups", section: "primary" },
  { name: "Support Hub", id: "support", section: "primary" },

  // ── Secondary: Learning & Resources ──
  { name: "Silent Light Publishers", id: "publishers", section: "secondary" },
  { name: "Advertising & Marketing", id: "marketing", section: "secondary" },
  { name: "Business & Practice", id: "business", section: "secondary" },
  { name: "Life Mastery", id: "mastery", section: "secondary" },
  { name: "A Course in Miracles", id: "miracles", section: "secondary" },
  { name: "Online Monastery", id: "monastery", section: "secondary" },
  { name: "World Happiness", id: "happiness", section: "secondary" },
  { name: "CEU Courses", id: "ceu", section: "secondary" },
  { name: "Conferences", id: "conferences", section: "secondary" },
  { name: "Grow with Us", id: "grow", section: "secondary" },
  { name: "Meditations", id: "meditations", section: "secondary" },
  { name: "Podcasts", id: "podcasts", section: "secondary" },
  { name: "IIH Ambassador", id: "ambassadorForm", section: "secondary" },

  // ── Admin (role: admin only) ──
  { name: "Practitioners", id: "adminPractitioners", section: "admin", requiresAdmin: true },
  { name: "Blog Moderation", id: "blogModeration", section: "admin", requiresAdmin: true },
  { name: "Newsletter Subscribers", id: "newsletterSubscribers", section: "admin", requiresAdmin: true },

  // ── Disabled ──
  // { name: "Session Exchange", id: "exchange" },
  // { name: "IHPC Clinic", id: "clinic" },
  // { name: "NLP Training", id: "nlp" },
  // { name: "IGE Networking Groups", id: "networking" },
  // { name: "Community Practice Groups", id: "students" },
  // { name: "Booking", id: "booking" },
];

export const clinicData = [
  {
    id: 1,
    title: "Online Calendar for scheduling and appointment management.",
    link: "https://calendly.com/login",
  },
  {
    id: 2,
    title:
      "Customer Relationship Management (CRM) Software to organize and manage client relationships.",
  },
  {
    id: 3,
    title: "Networking Opportunities with other hypnotherapy professionals.",
  },
  { id: 4, title: "Mentor Support for guidance and professional development." },
  {
    id: 5,
    title:
      "Clinic Database Listing/Checklist to ensure visibility and maintain clinic standards.",
  },
];

export const bookPromosData = [
  {
    id: 1,
    title: "The sutras of healing and englightenment",
    image: require("../images/book1.png"),
    link: "https://www.amazon.com/gp/product/1518743552/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1518743552&linkCode=as2&tag=silentlightpu-20&linkId=c8fc19aeb78b7c2d94af473f2daaaaf4",
  },
  {
    id: 2,
    title: "The Anahat Meditation System",
    image: require("../images/book2.png"),
    link: "https://www.amazon.com/gp/product/1518763685/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1518763685&linkCode=as2&tag=silentlightpu-20&linkId=2c5e371cae0da701270eaf7f4dfbb788",
  },
  {
    id: 3,
    title: "interpersonal hypnotherapy",
    image: require("../images/book3.png"),
    link: "https://www.amazon.com/gp/product/1495289087/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1495289087&linkCode=as2&tag=silentlightpu-20&linkId=0971c1ce2daaa38cd66b591d260efe06",
  },
  {
    id: 4,
    title: "The Sacred Geometry of Meditation",
    image: require("../images/book4.png"),
    link: "https://www.amazon.com/gp/product/1544983468/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1544983468&linkCode=as2&tag=silentlightpu-20&linkId=d054f812a081c77fd7bf20aab9679926",
  },
  {
    id: 5,
    title: "Peace under all circumstances",
    image: require("../images/book5.png"),
    link: "https://www.amazon.com/gp/product/151877024X/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=151877024X&linkCode=as2&tag=silentlightpu-20&linkId=d4b522b3af820b944fd5ba373efe578b",
  },
];

export const marketingData = [
  {
    id: 1,
    title: "Goal Setting",
    text: "Set goals and track your progress using the <b>Anahat Education Group Dashboard.</b>",
    type: "calculator",
    link: false,
  },
  {
    id: 2,
    title: "Hypnotherapy Accelerator",
    text: "Enjoy significant discounts on web design and marketing services with IIH graduate Corey Benschop. Access essential business tools such as:",
    type: "tags",
    tags: [
      "Booking software",
      "Customer relationship management (CRM) software",
      "Online calendar",
      "Email marketing solutions",
    ],
    bottomText: "And more!",
    link: "https://www.instituteofhypnotherapy.com/hypnotherapy-accelerator/",
  },
  {
    id: 3,
    title: "IAIH Online Directory",
    text: "As an IAIH member, receive a free public-facing listing on the IIH website. Your listing includes:",
    type: "tags",
    tags: [
      "Photo",
      "Bio",
      "Social media links",
      "Credentials",
      "External website link",
    ],
    bottomText: "And more!",
    link: false,
    modal: false,
  },
  {
    id: 4,
    title: "Success Checklist",
    text: "Begin your step-by-step journey to establish your hypnotherapy business, whether online or in a private office.",
    modal: true,
    link: true,
  },
];

export const checklistData = [
  // {
  //   id: 1,
  //   title: "Legal Structure and Registration:",
  //   bulletPoints: [
  //     {
  //       text: "Choose a legal structure for your business (sole proprietorship, partnership, LLC, corporation, etc.).",
  //     },
  //     {
  //       text: "Register your business with the appropriate government authorities.",
  //     },
  //   ],
  //   value: "legal",
  // },
  // {
  //   id: 2,
  //   title: "Get an EIN (Employer Identification Number):",
  //   bulletPoints: [
  //     {
  //       text: "Obtain a free EIN from the IRS.",
  //       subPoints: [
  //         "Note – It is best to wait until your LLC is approved by the state before applying for an EIN.",
  //         "Note - A single-member LLC without employees is not required to obtain an EIN, yet it is beneficial if you are planning to open a business bank account.",
  //       ],
  //     },
  //   ],
  //   value: "ein",
  // },
  // {
  //   id: 3,
  //   title: "Business Tax Receipt:",
  //   bulletPoints: [
  //     { text: "Register with the city and county for a Business Tax Receipt." },
  //     {
  //       text: "Reach out to Matthew if you experience any issues during the application process - matthew@anahateducation.com.",
  //     },
  //   ],
  //   value: "taxReceipts",
  // },
  // {
  //   id: 4,
  //   title: "Open a Business Bank Account:",
  //   bulletPoints: [
  //     {
  //       text: "Separate your personal and business finances by opening a business bank account.",
  //     },
  //     { text: "Use your EIN when applying for the account." },
  //   ],
  //   value: "banking",
  // },
  // {
  //   id: 5,
  //   title: "Insurance:",
  //   bulletPoints: [
  //     {
  //       text: "Consider getting business insurance to protect your LLC from potential risks.",
  //     },
  //     {
  //       text: "Types of insurance may include general liability, professional liability, or property insurance.",
  //       subPoints: [
  //         "Visit the school’s website, IAIH - IAIH Advocacy & Resources - Liability Insurance for more information.",
  //       ],
  //     },
  //   ],
  //   value: "insurance",
  // },
  // {
  //   id: 6,
  //   title:
  //     "HIPPA Compliancy (for anyone planning on doing Therapeutic Hypnotherapy):",
  //   bulletPoints: [
  //     {
  //       text: "There are two training courses, one for awareness and one for security.",
  //     },
  //     {
  //       text: "Client rights & Therapist duties form is available for purchase.",
  //     },
  //     {
  //       text: "Visit the school’s website, IAIH - IAIH Advocacy & Resources - HIPPA Compliance for more information.",
  //     },
  //   ],
  //   value: "hippa",
  // },
  {
    id: 7,
    title: "Domain Name:",
    bulletPoints: [{ text: "Secure your domain name." }],
    value: "domainName",
  },
  {
    id: 8,
    title: "Website:",
    bulletPoints: [
      {
        text: "Done for you: Corey offers a website building service through dharma.tools. Revisit HT202 Advertising and Marketing Strategies for more information.",
      },
      {
        text: "DIY: If you plan to make your own, there are several options to choose from: Wix, GoDaddy, Squarespace, etc.",
      },
    ],
    value: "website",
  },
  {
    id: 9,
    title: "Create a Google My Business Profile:",
    bulletPoints: [
      {
        text: "https://www.google.com/business/",
        subPoints: [
          "Creates an online presence when people search locally for hypnotherapists (your reviews will be listed here as well).",
          "Additionally, it’s a good option to have because SEO can take a bit to rank your website high enough to be customer facing, especially if there are a lot of other similar practitioners in your area.",
        ],
      },
    ],
    value: "businessProfile",
  },
  {
    id: 10,
    title: "Search Engine Optimization (SEO):",
    bulletPoints: [
      {
        text: "Optimize your website for search engines to increase its visibility. This includes using relevant keywords related to Hypnotherapy. Having a blog can boost SEO.",
        subPoints: [
          "If you are not comfortable with SEO yet, there are professionals you can hire to assist with this.",
          "The most important thing to remember is to be consistent when updating this.",
        ],
      },
    ],
    value: "seo",
  },
  {
    id: 11,
    title:
      "Accounting (to keep track of income/expenses, invoices/payments, and more):",
    bulletPoints: [{ text: "Quick Books" }, { text: "Fresh Books" }],
    value: "accounting",
  },
  {
    id: 12,
    title: "Business cards:",
    bulletPoints: [
      { text: "Vistaprint" },
      { text: "Zazzle" },
      { text: "Staples" },
    ],
    value: "businessCards",
  },
  {
    id: 13,
    title: "Brochures:",
    bulletPoints: [
      {
        text: "Trifold with bullet points, pictures, ‘what people are saying’ (showcase a few short testimonials), contact info, and a section offering a free consultation.",
      },
    ],
    value: "brochures",
  },
  {
    id: 14,
    title: "Google Pay Per Click:",
    bulletPoints: [
      {
        text: "Once you create a Google My Business Profile, you can start advertising on Google – this will show your post as ‘sponsored’ and usually at the top of the search results. Target specific clientele. If your campaign is too general, more people will click and burn through your budget.",
      },
    ],
    value: "payPerClick",
  },
  {
    id: 15,
    title: "Social Media:",
    bulletPoints: [
      { text: "Hypnotic recordings" },
      { text: "Collaborating with other professionals" },
      { text: "Education" },
      { text: "Teaching" },
      { text: "Q & A’s" },
      {
        text: "Share success stories (keeping clients PHI safe is top priority)",
      },
      {
        text: "Appealing visuals with inspirational quotes (be sure to give credit when due)",
      },
      {
        text: "Clips debunking common myths (good for TikTok, YT Shorts, and IG Reels)",
      },
      { text: "Meetup" },
      { text: "LinkedIn" },
      { text: "Calendar of Events" },
      { text: "Public Service Announcements" },
    ],
    value: "socialMedia",
  },
  {
    id: 16,
    title: "Health and Wellness Websites:",
    bulletPoints: [
      {
        text: "Showcase your expertise, share success stories, and propose content ideas that align with their audience.",
      },
    ],
    value: "wellnessWebsite",
  },
  {
    id: 17,
    title: "Podcast:",
    bulletPoints: [
      { text: "Start your own or guest speak on others." },
      {
        text: "Paid advertisements on popular podcasts related to your field.",
      },
    ],
    value: "podcast",
  },
  {
    id: 18,
    title: "Radio:",
    bulletPoints: [
      {
        text: "Advertising for an upcoming class or event, interviewing a guest, educating listeners, etc.",
      },
    ],
    value: "radio",
  },
  {
    id: 19,
    title: "Television:",
    bulletPoints: [
      { text: "Reach out to local stations to inquire about their rates." },
      {
        text: "Hire professionals to advertise your service or be the face of your brand. Work with a production service to produce high-quality content suitable for TV.",
        subPoints: [
          "Note: The sales representatives may potentially become your client, even if you decide not to go with their service.",
        ],
      },
    ],
    value: "tv",
  },
  {
    id: 20,
    title: "Networking Groups:",
    bulletPoints: [
      { text: "BNI" },
      { text: "Chamber of Commerce" },
      { text: "Rotary Club" },
      { text: "American Markets Association" },
      { text: "LinkedIn Groups" },
    ],
    value: "networkingGroups",
  },
  {
    id: 21,
    title: "Lectures:",
    bulletPoints: [
      { text: "Lunch and Learns" },
      { text: "Libraries" },
      { text: "Book Stores" },
      { text: "Senior Centers" },
      { text: "Women’s Groups" },
    ],
    value: "lectures",
  },
  {
    id: 22,
    title: "Free Classes:",
    bulletPoints: [
      { text: "Life Mastery" },
      { text: "Shadow Self" },
      { text: "Breath Work" },
      { text: "Pain Management" },
      { text: "Self-Hypnosis" },
      { text: "Stress Reduction" },
      { text: "Past Life Regression" },
      { text: "Astral Travel" },
      { text: "Course in Miracles" },
      { text: "Yoga" },
      { text: "Meditation" },
    ],
    value: "freeClasses",
  },
  {
    id: 23,
    title: "Coupon Books:",
    bulletPoints: [{ text: "Good for smoking/weight loss." }],
    value: "couponBooks",
  },
  {
    id: 24,
    title: "Magazine:",
    bulletPoints: [
      { text: "Publish your own or guest write on one already established." },
      {
        text: "If you do a paid advertisement, inquire about writing an article to go along with your ad – this will give you more exposure in the magazine.",
      },
    ],
    value: "magazine",
  },
  {
    id: 25,
    title: "Mailing Lists:",
    bulletPoints: [
      {
        text: "Reach out to local community groups to inquire about a mailing list. Send a letter sharing your connection to the group/cause, why you are reaching out, and offer a reduced price if they are interested in your services.",
      },
    ],
    value: "mailingLists",
  },
  {
    id: 26,
    title: "Bulletin Boards: (Simple flyers with pull-off tabs work well)",
    bulletPoints: [
      { text: "Coffee shops" },
      { text: "Gyms" },
      { text: "New age shops" },
      { text: "Book Stores" },
      { text: "Yoga studios" },
      { text: "Laundromats" },
      { text: "Public transit stations" },
      { text: "Restaurants" },
      { text: "Community centers" },
      { text: "Libraries" },
      { text: "Univeristy Campuses" },
    ],
    value: "bulletinBoards",
  },
  {
    id: 27,
    title: "Continuing Education:",
    bulletPoints: [
      {
        text: "Interpersonal Hypnotherapist Certification Course",
        subPoints: [
          "CEU Credits: 22 Hours",
          "Credential Awarded: Certified Interpersonal Hypnotherapist, CIHt",
        ],
      },
      {
        text: "There are others available as well. Visit the school’s website, IAIH - Continuing Education Units and Courses ",
      },
    ],
    value: "continuingEducation",
  },
  {
    id: 28,
    title: "IAIH Membership:",
    bulletPoints: [
      {
        text: "Option Four (for those doing the additional training for Interpersonal)",
        subPoints: [
          "Certified Hypnotherapist, Clinical, Transpersonal, and Interpersonal Hypnotherapist",
          "Visit the school’s website, IAIH - IAIH Membership ",
        ],
      },
    ],
    value: "iaih",
  },
];

export const businessPracticeData = [
  {
    id: 1,
    text: "<b>Legal Structure and Registration –</b> Guidance on choosing and registering the right business entity.",
    value: "legal",
  },
  {
    id: 2,
    text: "<b>Getting an EIN (Employer Identification Number) –</b> Assistance with federal tax identification.",
    value: "ein",
  },
  {
    id: 3,
    text: "<b>Business Tax Receipt –</b> Ensuring compliance with local business regulations.",
    value: "taxReceipts",
  },
  {
    id: 4,
    text: "<b>Banking –</b> Setting up business accounts for financial management.",
    value: "banking",
  },
  {
    id: 5,
    text: "<b>Bookkeeping and Accounting –</b> Tools and tips for maintaining accurate records.",
    value: "bookkeeping",
  },
  {
    id: 6,
    text: "<b>Investing –</b> Strategies for financial growth and security.",
    value: "investing",
  },
  {
    id: 7,
    text: "<b>Creating Multiple Prosperous Income Streams –</b> Ideas to diversify and expand your earnings.",
    value: "incomeStreams",
  },
  {
    id: 8,
    text: "<b>Paying Taxes –<b/> Insights on tax preparation and filing",
    value: "payingTaxes",
  },
  {
    id: 9,
    text: "<b>Liability Insurance –</b> Protecting your practice and clients.",
    value: "liabilityInsurance",
  },
  {
    id: 10,
    text: "<b>Calendar/Booking Systems –</b> Efficient scheduling solutions for your practice.",
    value: "calendar",
  },
  {
    id: 11,
    text: "<b>CRM (Customer Relationship Management) Software –</b> Tools to build and manage client relationships.",
    value: "crm",
  },
  {
    id: 12,
    text: "<b>HIPAA Compliance –</b> Ensuring client confidentiality and legal compliance.",
    link: "https://www.instituteofhypnotherapy.com/iaih-hipaa-compliance/",
    value: "hipaa",
  },
  {
    id: 13,
    text: "<b>Domain Name and Website –</b> Establishing your online presence.",
    link: "https://www.instituteofhypnotherapy.com/hypnotherapy-accelerator/",
    value: "domainName",
  },
  {
    id: 14,
    text: "<b>Google My Business Profile –</b> Improving visibility for local search results.",
    value: "businessProfile",
  },
  {
    id: 15,
    text: "<b>Advertising and Marketing –</b> Promoting your services effectively.",
    value: "advertising",
  },
  {
    id: 16,
    text: "<b>CEUs (Continuing Education Units) –</b> Staying current in your profession.",
    link: "https://www.instituteofhypnotherapy.com/ceu/interpersonal-hypnotherapist-certification-co",
    value: "ceu",
  },
  {
    id: 17,
    text: "<b>IAIH Membership –</b> Joining a network of certified professionals for ongoing support.",
    link: "https://www.instituteofhypnotherapy.com/iaih-membership/",
    value: "membership",
  },
];

export const networkingData = [
  {
    id: 1,
    title: "Student Practice Groups",
    text: "Practice hypnotherapy online in designated study groups tailored to specific cohorts.",
  },
  {
    id: 2,
    title: "Session Exchange",
    text: "Connect with an IIH student or graduate for private sessions at no cost.",
    text2:
      "A `heal the healer` model designed to provide therapeutic benefits for both parties.",
  },
  {
    id: 3,
    title: "Monthly IGE Business Networking Support Groups",
    text: "Monthly meetings for business networking, public speaking skill refinement, and professional support.",
    text2:
      "Opportunities to make friends, find mentors, and promote your services.",
  },
  {
    id: 4,
    title: "Regular Meetings",
    text: "Weekly, bi-weekly, or monthly meetings to build consistency and foster relationships.",
    text2:
      "Structured agendas with introductions, announcements, and networking activities.",
  },
  {
    id: 5,
    title: "Membership Directory",
    text: "Comprehensive listings of members, including contact information and business details.",
    text2: "Easy-to-access online directories.",
  },
  {
    id: 6,
    title: "Referral System",
    text: "Mechanisms for exchanging referrals and rewarding successful leads.",
  },
  {
    id: 7,
    title: "Educational Components",
    text: "Access to workshops, webinars, and guest speakers covering business and personal development topics.",
  },
  {
    id: 8,
    title: "Industry Exclusivity",
    text: "Groups may limit membership to one professional per industry to reduce competition.",
  },
  {
    id: 9,
    title: "Networking Events",
    text: "Social gatherings, mixers, and open-house meetings to encourage relationship building.",
  },
  {
    id: 10,
    title: "Collaboration Opportunities",
    text: "Support for partnerships on projects and complementary services.",
    text2: "Peer mentorship for knowledge sharing.",
  },
  {
    id: 11,
    title: "Online Presence",
    text: "Dedicated platforms for group communication, resource sharing, and scheduling.",
  },
  {
    id: 12,
    title: "Business Showcases",
    text: "Opportunities to present and promote your business during meetings.",
    text2: "Spotlighting member achievements and expertise.",
  },
  {
    id: 13,
    title: "Accountability and Goal Tracking",
    text: "Systems to support business objectives and track progress.",
  },
  {
    id: 14,
    title: "Community Involvement",
    text: "Engagement in charitable events and opportunities to give back.",
  },
  {
    id: 15,
    title: "Cross-Promotion",
    text: "Tools for sharing promotional materials and boosting visibility.",
  },
  {
    id: 16,
    title: "Membership Benefits",
    text: "Access to discounts, exclusive tools, and networking opportunities with leaders.",
  },
  {
    id: 17,
    title: "Focus on Trust and Relationship Building",
    text: "Prioritizing long-term relationships over immediate sales.",
  },
  {
    id: 18,
    title: "Diverse Membership",
    text: "A wide range of industries and professions to encourage innovation and varied connections.",
  },
];

export const monasteryData = [
  {
    id: 1,
    title: "Access Training Videos",
    text: "Easily view the full library of Anahat Meditation System Training videos.",
    type: "clickable",
    link: "https://www.instituteofhypnotherapy.com/anahat-meditation-system/",
  },
  {
    id: 2,
    title: "Sign Up and Acknowledge Your Start Date",
    text: "Record the date you begin your journey to mark your progress.",
    type: "clickable",
    link: "https://www.instituteofhypnotherapy.com/online-monastery/#anahatreg",
  },
  {
    id: 3,
    title: "Track Your Progress",
    text: "Use the dashboard to monitor your advancement through the training materials.",
    type: "clickable",
    modal: "progress",
  },
  {
    id: 4,
    title: "Submit Your Final Essay",
    text: "Complete your certification process by submitting the required essay directly through the platform.",
    type: "clickable",
    modal: "essay",
  },
];

export const exchangeData = [
  {
    id: 1,
    title: "Eligibility",
    text: "Participants must have completed at least <b>100 hours of IIH Training</b> to access the system.",
  },
  {
    id: 2,
    title: "How It Works",
    text2:
      "<ol><li>Fill out the form with your preferences for a practitioner.<ul> <li>Gender: Male, Female, or Other</li><li>Status: Student or Graduate</li><li>Level of Training Completed</li></ul></ol>",

    list: true,
  },
  {
    id: 3,
    title: "Benefits",
    text: "Practice your hypnotherapy skills in real-world settings.",
    text2:
      "Receive hypnotherapy sessions to support your own growth and well-being.",
  },
  {
    id: 4,
    title: "Submit a Session Request",
    text: "Fill out the form with your session preferences to connect with practitioners.",
    modal: true,
  },
  {
    id: 5,
    title: "My Session Requests",
    text: "Track your session requests and stay updated on practitioner responses.",
    page: true,
    filter: true,
  },
  {
    id: 6,
    title: "All Sessions Request",
    text: "Manage and coordinate your upcoming sessions with selected practitioners.",
    page: true,
  },
];

export const setupSessionData = [
  {
    id: 1,
    title: "Emily Johnson",
    training: 9,
    price: "$1500.99",
    tags: [
      "Stress Management through Hypnosis",
      "Cognitive Behavioral Hypnotherapy",
      "Sleep Hypnotherapy",
      "Pain Relief Hypnotherapy",
      "Hypnotherapy for Anxiety",
    ],
  },
  {
    id: 2,
    title: "Michael Anderson",
    training: 5,
    price: "$1200.99",
    tags: [
      "Smoking Cessation Hypnotherapy",
      "Cognitive Behavioral Hypnotherapy",
      "Sleep Hypnotherapy",
      "Pain Relief Hypnotherapy",
      "Hypnotherapy for Anxiety",
    ],
  },
  {
    id: 3,
    title: "Michael Anderson",
    training: 5,
    price: "$1200.99",
    tags: [
      "Smoking Cessation Hypnotherapy",
      "Confidence Building Hypnosis",
      "Trauma Recovery Hypnotherapy",
      "Weight Management Hypnosis",
      "Hypnotherapy for Focus and Clarity",
    ],
  },
];

export const meditationsData = [
  {
    id: 1,
    title: "Stress Reduction and Relaxation",
    text: "Guided sessions to help you unwind, manage stress, and find inner peace.",
    link: "https://youtu.be/zNJJt48LSvk",
  },
  {
    id: 2,
    title: "Self-Esteem and Confidence Building",
    text: "Meditations designed to enhance self-worth and personal empowerment.",
    link: "https://drive.google.com/drive/u/0/folders/1nR5-YHCNH6wfE1xzSSrnpEIgKu7eiWCt",
  },
  {
    id: 3,
    title: "Health and Wellness",
    text: "Sessions focused on improving physical health and mental well-being.",
    link: "https://drive.google.com/drive/u/0/folders/1nR5-YHCNH6wfE1xzSSrnpEIgKu7eiWCt",
  },
  {
    id: 4,
    title: "Spiritual Growth",
    text: "Meditations to deepen your spiritual practice and explore inner transformation.",
    link: "https://youtu.be/PoWZ7Og9BRU",
  },
  {
    id: 5,
    title: "Success and Goal Achievement",
    text: "Hypnotic programming to align your mind with your personal and professional goals.",
  },
  {
    id: 6,
    title: "Healing and Transformation",
    text: "Focused recordings to support emotional healing and overcoming limiting beliefs.",
  },
  {
    id: 7,
    title: "Custom Sessions by IIH Practitioners",
    text: "Unique recordings tailored to various needs by certified IIH professionals.",
  },
];

export const quickLinksData = [
  {
    id: 1,
    text: "Quickly access the information most relevant to your journey.",
  },
  { id: 2, text: "Stay organized and focused on your priorities." },
  { id: 3, text: "Customize your navigation for a streamlined experience." },
  { id: 4, text: "Search" },
  { id: 5, text: "Notifications" },
  { id: 6, text: "Personal Profile" },
];

export const wheelOfLifeCategories = [
  { label: "Spirituality", value: "spirituality" },
  { label: "Emotional Health", value: "health" },
  { label: "Physical Health", value: "physicalHealth" },
  { label: "Career", value: "career" },
  { label: "Relationships", value: "relationships" },
  { label: "Home", value: "home" },
  { label: "Transportation", value: "transportation" },
  { label: "Education", value: "education" },
  { label: "Recreation", value: "recreation" },
  // { label: "Philanthropy", value: "philanthropy" },
  { label: "Vacation", value: "vacation" },
];

export const wheelOfLifeCategoryColors = [
  "#6B9080", // Muted Teal
  "#A4C3B2", // Soft Sage
  "#E4C1F9", // Subtle Lavender
  "#E7AD99", // Warm Clay
  "#9A8C98", // Muted Mauve
  "#C3B299", // Earthy Sand
  "#748CAB", // Soft Denim
  "#DDA15E", // Warm Amber
  "#B56576", // Dusty Rose
  "#6D597A", // Deep Plum
  "#468FAF", // Muted Ocean Blue
  "#E29578", // Warm Coral
  "#ACACDE", // Soft Periwinkle
  "#8D99AE", // Muted Blue-Gray
  "#D9BF77", // Golden Beige
  "#556B2F", // Olive Green
];

export const lessonGroups = [
  {
    part: "Part I",
    lessons: [
      { id: 1, title: "Lessons 1 to 50" },
      { id: 2, title: "Review I" },
      { id: 3, title: "Lessons 61 to 80" },
      { id: 4, title: "Review II" },
      { id: 5, title: "Lessons 91 to 110" },
      { id: 6, title: "Review III" },
      { id: 7, title: "Lessons 121 to 140" },
      { id: 8, title: "Review IV" },
      { id: 9, title: "Lessons 151 to 170" },
      { id: 10, title: "Review V" },
      { id: 11, title: "Lessons 181 to 200" },
      { id: 12, title: "Review VI" },
    ],
  },
  {
    part: "Part II",
    lessons: [
      { id: 13, title: "(221 - 230) 1. What Is Forgiveness?" },
      { id: 14, title: "(231 - 240) 2. What Is Salvation?" },
      { id: 15, title: "(241 - 250) 3. What Is The World?" },
      { id: 16, title: "(251 - 260) 4. What Is Sin?" },
      { id: 17, title: "(261 - 270) 5. What Is The Body?" },
      { id: 18, title: "(271 - 280) 6. What Is The Christ?" },
      { id: 19, title: "(281 - 290) 7. What Is The Holy Spirit?" },
      { id: 20, title: "(291 - 300) 8. What Is The Real World?" },
      { id: 21, title: "(301 - 310) 9. What Is The Second Coming?" },
      { id: 22, title: "(311 - 320) 10. What Is The Last Judgment?" },
      { id: 23, title: "(321 - 330) 11. What Is Creation?" },
      { id: 24, title: "(331 - 340) 12. What Is The Ego?" },
      { id: 25, title: "(341 - 350) 13. What Is a Miracle?" },
      { id: 26, title: "(351 - 360) 14. What Am I?" },
      { id: 27, title: "(361 - 365) 15. Final Lessons" },
    ],
  },
];

export const groupsData = [
  { value: 1, label: "Lessons 1 to 50" },
  { value: 2, label: "Review I" },
  { value: 3, label: "Lessons 61 to 80" },
  { value: 4, label: "Review II" },
  { value: 5, label: "Lessons 91 to 110" },
  { value: 6, label: "Review III" },
  { value: 7, label: "Lessons 121 to 140" },
  { value: 8, label: "Review IV" },
  { value: 9, label: "Lessons 151 to 170" },
  { value: 10, label: "Review V" },
  { value: 11, label: "Lessons 181 to 200" },
  { value: 12, label: "Review VI" },
  { value: 13, label: "(221 - 230) 1. What Is Forgiveness?" },
  { value: 14, label: "(231 - 240) 2. What Is Salvation?" },
  { value: 15, label: "(241 - 250) 3. What Is The World?" },
  { value: 16, label: "(251 - 260) 4. What Is Sin?" },
  { value: 17, label: "(261 - 270) 5. What Is The Body?" },
  { value: 18, label: "(271 - 280) 6. What Is The Christ?" },
  { value: 19, label: "(281 - 290) 7. What Is The Holy Spirit?" },
  { value: 20, label: "(291 - 300) 8. What Is The Real World?" },
  { value: 21, label: "(301 - 310) 9. What Is The Second Coming?" },
  { value: 22, label: "(311 - 320) 10. What Is The Last Judgment?" },
  { value: 23, label: "(321 - 330) 11. What Is Creation?" },
  { value: 24, label: "(331 - 340) 12. What Is The Ego?" },
  { value: 25, label: "(341 - 350) 13. What Is a Miracle?" },
  { value: 26, label: "(351 - 360) 14. What Am I?" },
  { value: 27, label: "(361 - 365) 15. Final Lessons" },
];

export const introductions = [
  {
    id: 1,
    part: "Part I",
    content: `<hgroup class="my-6 text-center">
<h3 style="text-align: center;"><span style="font-size: 24pt;"><strong>Workbook for Students</strong></span></h3>
<h3 style="text-align: center;"><span style="font-size: 24pt;"><strong>Introduction</strong></span></h3>
<h3 style="text-align: center;">&nbsp;</h3>
</hgroup>
<div class="contentBody">
<div class="acim-text wb-intro">
<div data-paragraph-id="401#1">
<ol>
<li><span data-sentence-id="401#1:1">A theoretical foundation such as the text provides is necessary as a framework to make the exercises in this workbook meaningful.</span> <span data-sentence-id="401#1:2">&sup2;Yet it is doing the exercises that will make the goal of the course possible.</span> <span data-sentence-id="401#1:3">&sup3;An untrained mind can accomplish nothing.</span> <span data-sentence-id="401#1:4">⁴It is the purpose of this workbook to train your mind to think along the lines the text sets forth.</span></li>
<li><span data-sentence-id="401#2:1">The exercises are very simple.</span> <span data-sentence-id="401#2:2">&sup2;They do not require a great deal of time, and it does not matter where you do them.</span> <span data-sentence-id="401#2:3">&sup3;They need no preparation.</span> <span data-sentence-id="401#2:4">⁴The training period is one year.</span> <span data-sentence-id="401#2:5">⁵The exercises are numbered from 1 to 365.</span> <span data-sentence-id="401#2:6">⁶Do not undertake to do more than one set of exercises a day.</span></li>
<li><span data-sentence-id="401#3:1">The workbook is divided into two main sections, the first dealing with the undoing of the way you see now, and the second with the acquisition of true perception.</span> <span data-sentence-id="401#3:2">&sup2;With the exception of the review periods, each day&rsquo;s exercises are planned around one central idea, which is stated first.</span> <span data-sentence-id="401#3:3">&sup3;This is followed by a description of the specific procedures by which the idea for the day is to be applied.</span></li>
<li><span data-sentence-id="401#4:1">The purpose of the workbook is to train your mind in a systematic way to a different perception of everyone and everything in the world.</span> <span data-sentence-id="401#4:2">&sup2;The exercises are planned to help you generalize the lessons, so that you will understand that each of them is equally applicable to everyone and everything you see.</span></li>
<li><span data-sentence-id="401#5:1">Transfer of training in true perception does not proceed as does transfer of the training of the world.</span> <span data-sentence-id="401#5:2">&sup2;If true perception has been achieved in connection with any person, situation or event, total transfer to everyone and everything is certain.</span> <span data-sentence-id="401#5:3">&sup3;On the other hand, one exception held apart from true perception makes its accomplishments anywhere impossible.</span></li>
<li><span data-sentence-id="401#6:1">The only general rules to be observed throughout, then, are: First, that the exercises be practiced with great specificity, as will be indicated.</span> <span data-sentence-id="401#6:2">&sup2;This will help you to generalize the ideas involved to every situation in which you find yourself, and to everyone and everything in it.</span> <span data-sentence-id="401#6:3">&sup3;Second, be sure that you do not decide for yourself that there are some people, situations or things to which the ideas are inapplicable.</span> <span data-sentence-id="401#6:4">⁴This will interfere with transfer of training.</span> <span data-sentence-id="401#6:5">⁵The very nature of true perception is that it has no limits.</span> <span data-sentence-id="401#6:6">⁶It is the opposite of the way you see now.</span></li>
<li><span data-sentence-id="401#7:1">The overall aim of the exercises is to increase your ability to extend the ideas you will be practicing to include everything.</span> <span data-sentence-id="401#7:2">&sup2;This will require no effort on your part.</span> <span data-sentence-id="401#7:3">&sup3;The exercises themselves meet the conditions necessary for this kind of transfer.</span></li>
<li><span data-sentence-id="401#8:1">Some of the ideas the workbook presents you will find hard to believe, and others may seem to be quite startling.</span> <span data-sentence-id="401#8:2">&sup2;This does not matter.</span> <span data-sentence-id="401#8:3">&sup3;You are merely asked to apply the ideas as you are directed to do.</span> <span data-sentence-id="401#8:4">⁴You are not asked to judge them at all.</span> <span data-sentence-id="401#8:5">⁵You are asked only to use them.</span> <span data-sentence-id="401#8:6">⁶It is their use that will give them meaning to you, and will show you that they are true.</span></li>
<li><span data-sentence-id="401#9:1">Remember only this; you need not believe the ideas, you need not accept them, and you need not even welcome them.</span> <span data-sentence-id="401#9:2">&sup2;Some of them you may actively resist.</span> <span data-sentence-id="401#9:3">&sup3;None of this will matter, or decrease their efficacy.</span> <span data-sentence-id="401#9:4">⁴But do not allow yourself to make exceptions in applying the ideas the workbook contains, and whatever your reactions to the ideas may be, use them.</span> <span data-sentence-id="401#9:5">⁵Nothing more than that is required.</span></li>
</ol>
</div>
</div>
</div>`,
  },
  {
    id: 2,
    part: "Part II",
    content: `<hgroup class="my-6 text-center">
<h3 style="text-align: center;"><span style="font-size: 24pt;">Part II</span></h3>
<h3 style="text-align: center;"><span style="font-size: 24pt;">Introduction</span></h3>
<h3 style="text-align: center;">&nbsp;</h3>
</hgroup>
<div class="contentBody">
<div class="acim-text wb-part2-intro">
<div data-paragraph-id="631#1">
<ol>
<li class="p-normal"><span data-sentence-id="631#1:1">Words will mean little now.</span> <span data-sentence-id="631#1:2">&sup2;We use them but as guides on which we do not now depend.</span> <span data-sentence-id="631#1:3">&sup3;For now we seek direct experience of truth alone.</span> <span data-sentence-id="631#1:4">⁴The lessons that remain are merely introductions to the times in which we leave the world of pain, and go to enter peace.</span> <span data-sentence-id="631#1:5">⁵Now we begin to reach the goal this course has set, and find the end toward which our practicing was always geared.</span></li>
<li class="p-normal"><span data-sentence-id="631#2:1">Now we attempt to let the exercise be merely a beginning.</span> <span data-sentence-id="631#2:2">&sup2;For we wait in quiet expectation for our God and Father.</span> <span data-sentence-id="631#2:3">&sup3;He has promised He will take the final step Himself.</span> <span data-sentence-id="631#2:4">⁴And we are sure His promises are kept.</span> <span data-sentence-id="631#2:5">⁵We have come far along the road, and now we wait for Him.</span> <span data-sentence-id="631#2:6">⁶We will continue spending time with Him each morning and at night, as long as makes us happy.</span> <span data-sentence-id="631#2:7">⁷We will not consider time a matter of duration now.</span> <span data-sentence-id="631#2:8">⁸We use as much as we will need for the result that we desire.</span> <span data-sentence-id="631#2:9">⁹Nor will we forget our hourly remembrance in between, calling to God when we have need of Him as we are tempted to forget our goal.</span></li>
<li class="p-normal"><span data-sentence-id="631#3:1">We will continue with a central thought for all the days to come, and we will use that thought to introduce our times of rest, and calm our minds at need.</span> <span data-sentence-id="631#3:2">&sup2;Yet we will not content ourselves with simple practicing in the remaining holy instants which conclude the year that we have given God.</span> <span data-sentence-id="631#3:3">&sup3;We say some simple words of welcome, and expect our Father to reveal Himself, as He has promised.</span> <span data-sentence-id="631#3:4">⁴We have called on Him, and He has promised that His Son will not remain unanswered when he calls His Name.</span></li>
<li class="p-normal"><span data-sentence-id="631#4:1">Now do we come to Him with but His Word upon our minds and hearts, and wait for Him to take the step to us that He has told us, through His Voice, He would not fail to take when we invited Him.</span> <span data-sentence-id="631#4:2">&sup2;He has not left His Son in all his madness, nor betrayed his trust in Him.</span> <span data-sentence-id="631#4:3">&sup3;Has not His faithfulness earned Him the invitation that He seeks to make us happy?</span> <span data-sentence-id="631#4:4">⁴We will offer it, and it will be accepted.</span> <span data-sentence-id="631#4:5">⁵So our times with Him will now be spent.</span> <span data-sentence-id="631#4:6">⁶We say the words of invitation that His Voice suggests, and then we wait for Him to come to us.</span></li>
<li class="p-normal"><span data-sentence-id="631#5:1">Now is the time of prophecy fulfilled.</span> <span data-sentence-id="631#5:2">&sup2;Now are all ancient promises upheld and fully kept.</span> <span data-sentence-id="631#5:3">&sup3;No step remains for time to separate from its accomplishment.</span> <span data-sentence-id="631#5:4">⁴For now we cannot fail.</span> <span data-sentence-id="631#5:5">⁵Sit silently and wait upon your Father.</span> <span data-sentence-id="631#5:6">⁶He has willed to come to you when you have recognized it is your will He do so.</span> <span data-sentence-id="631#5:7">⁷And you could have never come this far unless you saw, however dimly, that it is your will.</span></li>
<li class="p-normal"><span data-sentence-id="631#6:1">I am so close to you we cannot fail.</span> <span data-sentence-id="631#6:2">&sup2;Father, we give these holy times to You, in gratitude to Him Who taught us how to leave the world of sorrow in exchange for its replacement, given us by You.</span> <span data-sentence-id="631#6:3">&sup3;We look not backward now.</span> <span data-sentence-id="631#6:4">⁴We look ahead, and fix our eyes upon the journey&rsquo;s end.</span> <span data-sentence-id="631#6:5">⁵Accept these little gifts of thanks from us, as through Christ&rsquo;s vision we behold a world beyond the one we made, and take that world to be the full replacement of our own.</span></li>
<li class="p-normal"><span data-sentence-id="631#7:1">And now we wait in silence, unafraid and certain of Your coming.</span> <span data-sentence-id="631#7:2">&sup2;We have sought to find our way by following the Guide You sent to us.</span> <span data-sentence-id="631#7:3">&sup3;We did not know the way, but You did not forget us.</span> <span data-sentence-id="631#7:4">⁴And we know that You will not forget us now.</span> <span data-sentence-id="631#7:5">⁵We ask but that Your ancient promises be kept which are Your Will to keep.</span> <span data-sentence-id="631#7:6">⁶We will with You in asking this.</span> <span data-sentence-id="631#7:7">⁷The Father and the Son, Whose holy Will created all that is, can fail in nothing.</span> <span data-sentence-id="631#7:8">⁸In this certainty, we undertake these last few steps to You, and rest in confidence upon Your Love, which will not fail the Son who calls to You.</span></li>
<li class="p-normal"><span data-sentence-id="631#8:1">And so we start upon the final part of this one holy year, which we have spent together in the search for truth and God, Who is its one Creator.</span> <span data-sentence-id="631#8:2">&sup2;We have found the way He chose for us, and made the choice to follow it as He would have us go.</span> <span data-sentence-id="631#8:3">&sup3;His Hand has held us up.</span> <span data-sentence-id="631#8:4">⁴His Thoughts have lit the darkness of our minds.</span> <span data-sentence-id="631#8:5">⁵His Love has called to us unceasingly since time began.</span></li>
<li class="p-normal"><span data-sentence-id="631#9:1">We had a wish that God would fail to have the Son whom He created for Himself.</span> <span data-sentence-id="631#9:2">&sup2;We wanted God to change Himself, and be what we would make of Him.</span> <span data-sentence-id="631#9:3">&sup3;And we believed that our insane desires were the truth.</span> <span data-sentence-id="631#9:4">⁴Now we are glad that this is all undone, and we no longer think illusions true.</span> <span data-sentence-id="631#9:5">⁵The memory of God is shimmering across the wide horizons of our minds.</span> <span data-sentence-id="631#9:6">⁶A moment more, and it will rise again.</span> <span data-sentence-id="631#9:7">⁷A moment more, and we who are God&rsquo;s Sons are safely home, where He would have us be.</span></li>
<li class="p-normal"><span data-sentence-id="631#10:1">Now is the need for practice almost done.</span> <span data-sentence-id="631#10:2">&sup2;For in this final section, we will come to understand that we need only call to God, and all temptations disappear.</span> <span data-sentence-id="631#10:3">&sup3;Instead of words, we need but feel His Love.</span> <span data-sentence-id="631#10:4">⁴Instead of prayers, we need but call His Name.</span> <span data-sentence-id="631#10:5">⁵Instead of judging, we need but be still and let all things be healed.</span> <span data-sentence-id="631#10:6">⁶We will accept the way God&rsquo;s plan will end, as we received the way it started.</span> <span data-sentence-id="631#10:7">⁷Now it is complete.</span> <span data-sentence-id="631#10:8">⁸This year has brought us to eternity.</span></li>
<li class="p-normal"><span data-sentence-id="631#11:1">One further use for words we still retain.</span> <span data-sentence-id="631#11:2">&sup2;From time to time, instructions on a theme of special relevance will intersperse our daily lessons and the periods of wordless, deep experience which should come afterwards.</span> <span data-sentence-id="631#11:3">&sup3;These special thoughts should be reviewed each day, each one of them to be continued till the next is given you.</span> <span data-sentence-id="631#11:4">⁴They should be slowly read and thought about a little while, preceding one of the holy and blessed instants in the day.</span> <span data-sentence-id="631#11:5">⁵We give the first of these instructions now.</span></li>
</ol>
</div>
</div>
</div>`,
  },
];

export const timeZones = [
  { value: "UTC−12:00", label: "UTC−12:00 International Date Line West" },
  { value: "UTC−11:00", label: "UTC−11:00 Midway Island, Samoa" },
  { value: "UTC−10:00", label: "UTC−10:00 Hawaii" },
  { value: "UTC−09:00", label: "UTC−09:00 Alaska" },
  { value: "UTC−08:00", label: "UTC−08:00 Pacific Time (US & Canada)" },
  { value: "UTC−07:00", label: "UTC−07:00 Mountain Time (US & Canada)" },
  { value: "UTC−06:00", label: "UTC−06:00 Central Time (US & Canada)" },
  { value: "UTC−05:00", label: "UTC−05:00 Eastern Time (US & Canada)" },
  { value: "UTC−04:00", label: "UTC−04:00 Atlantic Time (Canada)" },
  { value: "UTC−03:00", label: "UTC−03:00 Buenos Aires, Georgetown" },
  { value: "UTC−02:00", label: "UTC−02:00 Mid-Atlantic" },
  { value: "UTC−01:00", label: "UTC−01:00 Azores, Cape Verde Islands" },
  { value: "UTC±00:00", label: "UTC±00:00 London, Lisbon, Casablanca" },
  { value: "UTC+01:00", label: "UTC+01:00 Berlin, Rome, Paris, Lagos" },
  { value: "UTC+02:00", label: "UTC+02:00 Athens, Cairo, Johannesburg" },
  { value: "UTC+03:00", label: "UTC+03:00 Moscow, Nairobi, Baghdad" },
  { value: "UTC+03:30", label: "UTC+03:30 Tehran" },
  { value: "UTC+04:00", label: "UTC+04:00 Dubai, Baku" },
  { value: "UTC+04:30", label: "UTC+04:30 Kabul" },
  { value: "UTC+05:00", label: "UTC+05:00 Karachi, Tashkent" },
  { value: "UTC+05:30", label: "UTC+05:30 New Delhi, Colombo" },
  { value: "UTC+05:45", label: "UTC+05:45 Kathmandu" },
  { value: "UTC+06:00", label: "UTC+06:00 Dhaka, Almaty" },
  { value: "UTC+06:30", label: "UTC+06:30 Yangon" },
  { value: "UTC+07:00", label: "UTC+07:00 Bangkok, Jakarta, Hanoi" },
  { value: "UTC+08:00", label: "UTC+08:00 Beijing, Singapore, Perth" },
  { value: "UTC+09:00", label: "UTC+09:00 Tokyo, Seoul" },
  { value: "UTC+09:30", label: "UTC+09:30 Adelaide, Darwin" },
  { value: "UTC+10:00", label: "UTC+10:00 Sydney, Guam" },
  { value: "UTC+11:00", label: "UTC+11:00 Magadan, Solomon Islands" },
  { value: "UTC+12:00", label: "UTC+12:00 Auckland, Fiji" },
  { value: "UTC+13:00", label: "UTC+13:00 Tonga, Samoa" },
];

export const categorizedPolicies = {
  onboarding: [
    {
      id: 24,
      title: "Practitioner Agreement (Independent Contractor)",
      link: PractitionerAgreement,
    },
    {
      id: 22,
      title: "Background Check Disclosure and Authorization",
      link: BackgroundCheck,
    },
    {
      id: 25,
      title: "Nirva Practitioner Scope of Practice",
      link: ScopeOfPractice,
    },
  ],
  sessionResources: [
    {
      id: 13,
      title: "Client Privacy Notice",
      link: "https://www.canva.com/design/DAG3-sQXze8/rWEn4R_suX3HP2wwQzJ0Dw/view?utm_content=DAG3-sQXze8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h3873499d20",
    },
    {
      id: 12,
      title: "Telehealth Informed Consent (Zoom for Healthcare)",
      link: TelehealthFile,
    },
    {
      id: 23,
      title: "Client Participation Agreement & Client Bill of Rights",
      link: ClientParticipation,
    },
  ],
  sopsPolicies: [
    {
      id: 1,
      title: "Acceptable Use / BYOD & Home-Office Policy",
      link: "https://www.canva.com/design/DAG3-ISXgNo/5juiU3AtmTaEpbMREO8sjA/view?utlId=h74cc128710",
    },
    {
      id: 2,
      title: "Social Media, Testimonials & Reviews Policy",
      link: "https://www.canva.com/design/DAG3-Bp-Sto/OakZEb7Hli59og30HAgB2A/view?utlId=h25e675966c",
    },
    {
      id: 3,
      title: "Financial & Cancellations Policy",
      link: "https://www.canva.com/design/DAG3-J-tu0c/Mke1Haw42ey_-BRAAVj44Q/view?utlId=h32703d868a",
    },
    {
      id: 4,
      title: "Grievances & Complaints Policy",
      link: "https://www.canva.com/design/DAG3-LGb0jI/EDIA2gs97f3HgRbXCEqpAQ/view?utlId=h8aa4556371",
    },
    {
      id: 5,
      title: "Presence of Others in Sessions",
      link: "https://www.canva.com/design/DAG3-UfxBiU/x-GBYzNYHUap6-b3C4miCg/view?utlId=h31a8b67df2",
    },
    {
      id: 6,
      title: "Photography / Recording Prohibition Policy",
      link: "https://www.canva.com/design/DAG3-dOzgMc/tUUDjOIx6OxcQPuukoCkrg/view?utlId=h04fd293cba",
    },
    {
      id: 7,
      title: "Minimum Necessary",
      link: "https://www.canva.com/design/DAG4xyYrrnY/Xm7Nc0rbhAOrUQlPBvHTGQ/view?utm_content=DAG4xyYrrnY&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hffa4a6feba",
    },
    {
      id: 8,
      title: "SMS/Email Communications Policy",
      link: "https://www.canva.com/design/DAG3-b5rjzs/1BGPscKjfxqyypgQvns9xw/view?utlId=h2d61224a6c",
    },
    {
      id: 9,
      title: "Incident Response SOP (Practitioner-Focused)",
      link: "https://www.canva.com/design/DAG4JULVRXU/_oIDfTT5zQfcCIe3rVzzlQ/view?utm_content=DAG4JULVRXU&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf60955e78f",
    },
    {
      id: 10,
      title: "Practitioner HIPAA Safe Templates",
      link: "https://www.canva.com/design/DAG4yG48v4c/-4A4sgSMjwkjye3V0zrczw/view?utm_content=DAG4yG48v4c&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h51d5a0ab2b",
    },
    {
      id: 11,
      title: "Privacy & Security Officer (PSO)",
      link: "https://www.canva.com/design/DAG4AxFf2Hs/7gmt9_T6bvHIvDafnRpPyg/view?utlId=h1f1ac7e7f7",
    },
    {
      id: 14,
      title: "Zoom for Healthcare Practitioner Walk-Through",
      link: "https://www.canva.com/design/DAG4yO2kymY/DR2S6RixnITEMPEjYQy5uA/view?utm_content=DAG4yO2kymY&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h9ab624bf0c",
    },
    {
      id: 15,
      title: "Clinical Records, Documentation, Retention & Deletion SOP",
      link: "https://www.canva.com/design/DAG6UR_8IwY/r7ZnOvVcE3pv7962ikZiCg/view?utm_content=DAG6UR_8IwY&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h9402a48351",
    },
    {
      id: 16,
      title: "Paid Ads Referral Program & Compensation | Practitioner Guide",
      link: "https://www.canva.com/design/DAG62-SK7x8/F8s5YqRcWH6AJxRZBXdFZA/view?utm_content=DAG62-SK7x8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h56751e5ee3",
    },
    {
      id: 17,
      title: "Rebook & Auto-Assignment SOP",
      link: "https://www.canva.com/design/DAG4JNE0YYg/qUPiMFbKuti6Yot3aQYAMw/view?utlId=h51947cf9ac",
    },
    {
      id: 18,
      title: "No-Show & Reschedule SOP",
      link: "https://www.canva.com/design/DAG4JH6MFZ8/dK9fTMj5ia4Isc1vrCW2Vg/view?utlId=hbe614bbc1b",
    },
    {
      id: 20,
      title: "Schedules, Utilization & Availability",
      link: "https://www.canva.com/design/DAG4KdO1PGs/EEy0VGPj-Kbu1G3p5S1geA/view?utlId=h75b6c648b2",
    },
    {
      id: 21,
      title: "Practitioner Service Level Agreements (SLAs)",
      link: "https://www.canva.com/design/DAG4KalZh1M/IZwjnWbjAQNIECCbVLj4Yw/view?utlId=h653b9f85fe",
    },
    {
      id: 26,
      title: "HIPAA-Compliant Zoom Configuration Checklist",
      link: "https://www.canva.com/design/DAG34NgNLCI/DZW2_DpEoaxJHo62PjlYrg/view?utm_content=DAG34NgNLCI&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hc297cd6d48",
    },
  ],
};
